var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 106,
    viewBox: "0 0 122 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.6187 95.0836L92.1439 95.2635L91.9793 92.0842L95.4541 91.9043L95.6187 95.0836Z",
    fill: "#2ECC71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6187 95.0836L92.1439 95.2635L91.9793 92.0842L95.4541 91.9043L95.6187 95.0836Z",
    stroke: "#2ECC71",
    strokeWidth: 1.10941
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.902 46.9127L119.456 45.5417L120.819 50.0675L116.265 51.4385L114.902 46.9127Z",
    fill: "#E74C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.902 46.9127L119.456 45.5417L120.819 50.0675L116.265 51.4385L114.902 46.9127Z",
    stroke: "#E74C3C",
    strokeWidth: 1.58037
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96159 27.3899L4.23395 24.3241L7.82997 25.8165L6.55762 28.8823L2.96159 27.3899Z",
    fill: "#F39C12"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96159 27.3899L4.23395 24.3241L7.82997 25.8165L6.55762 28.8823L2.96159 27.3899Z",
    stroke: "#F39C12",
    strokeWidth: 1.19831
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0136 12.3027L47.4529 10.2824L49.4452 6.77118L53.0059 8.7915L51.0136 12.3027Z",
    fill: "#3498DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0194 88.4109L49.959 89.0769L49.425 85.0195L54.4854 84.3535L55.0194 88.4109Z",
    fill: "#2ECC71"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0194 88.4109L49.959 89.0769L49.425 85.0195L54.4854 84.3535L55.0194 88.4109Z",
    stroke: "#2ECC71",
    strokeWidth: 1.52343
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9125 27.0024C91.3778 27.8599 91.0675 28.9296 90.2199 29.3895C89.3724 29.8494 88.3064 29.5266 87.8411 28.6692C87.3758 27.8117 87.6861 26.742 88.5337 26.2821C89.3812 25.8222 90.4471 26.1449 90.9125 27.0024Z",
    fill: "#2ECC71"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36208 40.6153C2.40368 41.0292 1.26607 40.533 0.82335 39.508C0.38063 38.4829 0.799324 37.3146 1.75773 36.9006C2.71613 36.4867 3.85374 36.9829 4.29646 38.0079C4.73918 39.033 4.32048 40.2013 3.36208 40.6153Z",
    fill: "#3498DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11846 103.102C8.22211 104.245 7.43158 105.253 6.35429 105.351C5.277 105.448 4.31816 104.599 4.21452 103.456C4.11087 102.313 4.9014 101.305 5.97869 101.207C7.05599 101.11 8.01482 101.959 8.11846 103.102Z",
    fill: "#2ECC71"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8822 77.8498C21.6458 76.5486 22.3925 75.3216 23.5486 75.1115C24.7046 74.9015 25.8352 75.7875 26.0715 77.0887C26.3079 78.39 25.5612 79.617 24.4052 79.827C23.2492 80.037 22.1186 79.151 21.8822 77.8498Z",
    fill: "#E74C3C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2198 64.4037C42.3515 63.9757 42.0049 62.9015 42.4461 62.0063C42.8873 61.1112 43.9505 60.7319 44.8188 61.1599C45.687 61.5879 46.0337 62.6622 45.5925 63.5573C45.1512 64.4524 44.088 64.8317 43.2198 64.4037Z",
    fill: "#3498DB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4112 101.207L50.4727 102.761L48.5343 104.314L48.1924 101.776L47.8505 99.2365L50.1309 100.222L52.4112 101.207Z",
    fill: "#F39C12"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2508 96.7545L14.3591 97.6867L12.4673 98.619L12.9528 96.115L13.4383 93.611L14.8446 95.1827L16.2508 96.7545Z",
    fill: "#2ECC71"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9882 82.0502L75.099 83.0943L73.2098 84.1383L73.4218 81.7356L73.6338 79.3328L75.311 80.6915L76.9882 82.0502Z",
    fill: "#F39C12"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7912 34.736L95.8712 32.3684L95.9512 30.0008L97.8484 31.0636L99.7457 32.1264L97.7685 33.4312L95.7912 34.736Z",
    fill: "#2ECC71"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2233 0.391297L84.3406 2.66269L84.4579 4.93408L82.4612 3.94366L80.4645 2.95324L82.3439 1.67227L84.2233 0.391297Z",
    fill: "#E74C3C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.97 2.5203L30.7352 4.48066L29.5004 6.44102L28.4445 4.1341L27.3885 1.82718L29.6793 2.17374L31.97 2.5203Z",
    fill: "#F39C12"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.343959 56.1782L1.24666 54.3827L2.14937 52.5873L3.23705 54.1054L4.32473 55.6234L2.33435 55.9008L0.343959 56.1782Z",
    fill: "#3498DB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M93.042 11.7056C95.5569 12.4569 98.2117 18.6648 100.603 22.9983",
    stroke: "#2ECC71",
    strokeWidth: 1.5692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 49,
    r: 40,
    fill: "#00AE9B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6494 49.2822L43.8962 43.0354L54.2284 53.3676L74.0305 33.5654L80.2774 39.8123L54.2284 65.8612L37.6494 49.2822Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6768 49.3579L53.5887 60.2698L74.9006 37.9019",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.5396fe27aa7bb848792dd5a241d99786.svg";
export { ForwardRef as ReactComponent };